import {RecordsDataRequestQueryParams} from '../types/records-table.types';

export const defaultRecordsDataRequestQueryParams: RecordsDataRequestQueryParams = {
  page: 0,
  size: 10,
  sort: [ 'id,desc' ]
}
